export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-reservation/:pageId',
        component: () => import('@/views/page/company/hotel/hotel-reservation/HotelReservation.vue'),
        name: 'hotel-reservation',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-reservation-create/:pageId',
        component: () => import('@/views/page/company/hotel/hotel-reservation/HotelReservationCreate.vue'),
        name: 'hotel-reservation-create',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-frontdesk/:pageId',
        component: () => import('@/views/page/company/hotel/hotel-frontdesk/HotelFrontDesk.vue'),
        name: 'hotel-frontdesk',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-bill/:ipdRegisterId/statement/:pageId',
        component: () => import('@/views/page/company/hotel/hotel-bill-statement/HotelBillStatement.vue'),
        name: 'hotel-bill-statement',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-bill/:ipdRegisterId/statement/:pageId/return/:invoiceId',
        component: () => import('@/views/page/company/hotel/hotel-bill-return/HotelBillReturn.vue'),
        name: 'hotel-bill-return',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-bill/:ipdRegisterId/statement/:pageId/partial-return/:invoiceId',
        component: () => import('@/views/page/company/hotel/hotel-bill-return/HotelBillPartialReturn.vue'),
        name: 'hotel-bill-partial-return',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-housekeeping/:pageId',
        component: () => import('@/views/page/company/hotel/hotel-housekeeping/HotelHousekeeping.vue'),
        name: 'hotel-housekeeping',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-room-status/:pageId',
        component: () => import('@/views/page/company/hotel/hotel-room-status/HotelRoomStatus.vue'),
        name: 'hotel-room-status',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/hotel-checkin/:pageId/:ipdRegisterId',
        component: () => import('@/views/page/company/hotel/hotel-checkin/HotelCheckin.vue'),
        name: 'hotel-checkin',
        meta: {
            requiresAuth: true
        }
    },
]
